import { Component } from '@angular/core';
import { GeneralServiceService } from 'src/app/general-service.service';
import { DatePipe } from '@angular/common';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-master-page',
  templateUrl: './master-page.component.html',
  styleUrls: ['./master-page.component.css']
})

export class MasterPageComponent{
  
  constructor(private generalService : GeneralServiceService,
    private datePipe: DatePipe, private authService : AuthService
  ){

  }

  current_page = 1;
  tab = 1;

  fetchTab : any

  razonSocial = '';
  numeroImmex = '';
  rfc = '';
  domicilioFiscal = '';
  extensionesDomicilio = '';

  formData = {
    Datos: {
      razonSocial: '',
      numeroImmex: '',
      rfc: '',
      domicilioFiscal: '',
      extensionesDomicilio: ''
    },
    Materiales: {
      razonSocial: '',
      rfc: '',
      arancelaria: '',
      arancelariaOperator:'',
      descripcion: '',
      descripcionOperator:'',
      unidad: '',
      unidadOperator:'',
      fecha: '',
      fechaOperator:''
    },
    Productos: {
      razonSocial: '',
      rfc: '',
      arancelaria: '',
      arancelariaOperator:'',
      descripcion: '',
      descripcionOperator:'',
      unidad: '',
      unidadOperator:'',
      fecha: '',
      fechaOperator:''
    },
    Entradas: {
      razonSocial: '',
      rfc: '',
      numero: '',
      numeroOperator:'',
      clave: '',
      claveOperator:'',
      fecha: '',
      fechaOperator:''
    },
    Utilizados: {
      razonSocial: '',
      rfc: '',
      numero: '',
      numeroOperator:'',
      descripcion: '',
      descripcionOperator:'',
      unidad: '',
      unidadOperator:'',
      cantidad: '',
      cantidadOperator:'',
      fecha: '',
      fechaOperator:''
    },
    Salidas: {
      razonSocial: '',
      rfc: '',
      numero: '',
      numeroOperator:'',
      clave: '',
      claveOperator:'',
      fecha: '',
      fechaOperator:''
    },
    Fijo: {
      razonSocial: '',
      rfc: '',
      numero: '',
      numeroOperator:'',
      descripcion: '',
      descripcionOperator:'',
      clave: '',
      claveOperator:'',
      fecha: '',
      fechaOperator:''
    },
    TempEntrada: {
      razonSocial: '',
      rfc: '',
      numero: '',
      numeroOperator:'',
      clave: '',
      claveOperator:'',
      fecha: '',
      fechaOperator:''
    },
    TempSalida: {
      razonSocial: '',
      rfc: '',
      numero: '',
      numeroOperator:'',
      clave: '',
      claveOperator:'',
      fecha: '',
      fechaOperator:''
    },
    Saldos: {
      razonSocial: '',
      rfc: '',
      arancelaria: '',
      arancelariaOperator:''
    },
    TempUtilizados: {
      razonSocial: '',
      rfc: '',
      numero: '',
      numeroOperator:'',
      descripcion: '',
      descripcionOperator:'',
      unidad: '',
      unidadOperator:'',
      fecha: '',
      fechaOperator:''
    },
  };

  data: any[] = [];
  headerKeys: string[] = [];
  currentPage: number = 1;
  pageSize: number = 10; // Fetch 10 records per page
  totalPages: number = 1;
  totalRecords: number = 0;
  filteredRecords: number = 0;
  tableView = false;
  displayedColumns: string[] = [];
  sortColumn = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  sessionExpiredMessage: string = '';

  fetchFields(tabName : any){
    this.tableView = false
    this.fetchTab = tabName
  }

  categoryValue : any
  ngOnInit(){
    this.categoryValue = this.generalService.getCategory() || sessionStorage.getItem("fetchedCategory");
  }

  trackEvent : any

  fetchDataDatosDetails() {
    this.tableView= false
    this.fetchTab = ''
    this.generalService.fetchDatosDataDetails().subscribe({
      next: (response) => {
        //console.log('API Response:', response);
        this.data = response.data;

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        if (this.data.length > 0) {
          this.headerKeys = Object.keys(this.data[0]);
          this.displayedColumns = [...this.headerKeys];
        }

        this.tableView = true;
        //this.updatePagination();
      },
      error: (error) => {
        this.data = []
        this.tableView = true;
        console.error('Error fetching data:', error);
      }
    });
  }

  fetchDataDatos() {
    const searchData = {
      location: sessionStorage.getItem("Location"),
      razon_social: this.formData.Datos.razonSocial,
      rfc: this.formData.Datos.rfc,
      numero_de_immex: this.formData.Datos.numeroImmex,
      domicilio_fiscal: this.formData.Datos.domicilioFiscal
    };

    this.generalService.fetchDatosData(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);
        this.data = response.data;

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        if (this.data.length > 0) {
          this.headerKeys = Object.keys(this.data[0]);
          this.displayedColumns = [...this.headerKeys];
        }
        this.tableView = true;
        //this.updatePagination();
      },
      error: (error) => {
        this.data = []
        this.tableView = true;
        console.error('Error fetching data:', error);
      }
    });
  }

  fetchDataMateriales() {
    this.trackEvent = 'fetchDataMateriales';
    const searchData = {
        razon_social: this.formData.Materiales.razonSocial,
        rfc: this.formData.Materiales.rfc,
        arancelaria: this.formData.Materiales.arancelaria,
        arancelariaOperator: this.formData.Materiales.arancelariaOperator,
        descripcion: this.formData.Materiales.descripcion,
        descripcionOperator: this.formData.Materiales.descripcionOperator,
        unidad: this.formData.Materiales.unidad,
        unidadOperator: this.formData.Materiales.unidadOperator,
        fecha: this.formData.Materiales.fecha ? this.datePipe.transform(this.formData.Materiales.fecha, 'yyyy-MM-dd') : '',
        fechaOperator: this.formData.Materiales.fechaOperator,
        start: (this.currentPage - 1) * this.pageSize,
        length: this.pageSize
    };
    //console.log("Fetching data with start:", searchData.start, "and length:", searchData.length);
    this.generalService.fetchDataMaterialesService(searchData).subscribe({
        next: (response) => {
            //console.log('API Response:', response);
            this.data = response.data.map((material: { fecha_de_alta: string | number | Date; }) => {
                return {
                    ...material,
                    fecha_de_alta: this.datePipe.transform(material.fecha_de_alta, 'yyyy-MM-dd')
                };
            });
  
            this.totalRecords = response.recordsTotal;
            this.filteredRecords = response.recordsFiltered;
  
            this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
            if (this.data.length > 0) {
                this.headerKeys = Object.keys(this.data[0]);
                this.displayedColumns = [...this.headerKeys];
            } else {
                this.headerKeys = [];
                this.displayedColumns = [];
            }

            this.tableView = true;
        },
        error: (error) => {
            this.data = [];
            this.headerKeys = [];
            this.displayedColumns = [];
            this.tableView = true;
            this.totalRecords = 0;
            this.filteredRecords = 0;
            this.totalPages = 1; // Reset totalPages on error
            console.error('Error fetching data:', error);

            if (error.status === 401) {
              const event = "session"
              this.authService.logout(event);
              console.log("Session expired");
            }
        }
    });
  }

  fetchDataProductos() {
    this.trackEvent = 'fetchDataProductos';
    const searchData = {
      razon_social: this.formData.Productos.razonSocial,
      rfc: this.formData.Productos.rfc,
      arancelaria: this.formData.Productos.arancelaria,
      arancelariaOperator: this.formData.Productos.arancelariaOperator,
      descripcion: this.formData.Productos.descripcion,
      descripcionOperator: this.formData.Productos.descripcionOperator,
      unidad: this.formData.Productos.unidad,
      unidadOperator: this.formData.Productos.unidadOperator,
      fecha: this.formData.Productos.fecha ? this.datePipe.transform(this.formData.Productos.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.Productos.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataProductosService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        this.data = response.data.map((Productos: { fecha_de_alta: string | number | Date; }) => {
          return {
            ...Productos,
            fecha_de_alta: this.datePipe.transform(Productos.fecha_de_alta, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);

        if (this.data.length > 0) {
          this.headerKeys = Object.keys(this.data[0]);
          this.displayedColumns = [...this.headerKeys];
          } else {
              this.headerKeys = [];
              this.displayedColumns = [];
          }
        this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
          this.authService.logout(event);
        }
      }
    });
  }

  fetchDataEntradas() {
    this.trackEvent = 'fetchDataEntradas';
    const searchData = {
      razon_social: this.formData.Entradas.razonSocial,
      rfc: this.formData.Entradas.rfc,
      numero: this.formData.Entradas.numero,
      numeroOperator: this.formData.Entradas.numeroOperator,
      clave: this.formData.Entradas.clave,
      claveOperator: this.formData.Entradas.claveOperator,
      fecha: this.formData.Entradas.fecha ? this.datePipe.transform(this.formData.Entradas.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.Entradas.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataEntradasService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        // Map through the data to transform fecha_de_alta
        this.data = response.data.map((Entradas: { fecha_de_pedimento: string | number | Date; }) => {
          return {
            ...Entradas,
            fecha_de_pedimento: this.datePipe.transform(Entradas.fecha_de_pedimento, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
            if (this.data.length > 0) {
                this.headerKeys = Object.keys(this.data[0]);
                this.displayedColumns = [...this.headerKeys];
            } else {
                this.headerKeys = [];
                this.displayedColumns = [];
            }

            this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
          this.authService.logout(event);
        }
      }
    });
  }

  fetchDataUtilizados() {
    this.trackEvent = 'fetchDataUtilizados';
    const searchData = {
      razon_social: this.formData.Utilizados.razonSocial,
      rfc: this.formData.Utilizados.rfc,
      numero: this.formData.Utilizados.numero,
      numeroOperator: this.formData.Utilizados.numeroOperator,
      descripcion: this.formData.Utilizados.descripcion,
      descripcionOperator: this.formData.Utilizados.descripcionOperator,
      unidad: this.formData.Utilizados.unidad,
      unidadOperator: this.formData.Utilizados.unidadOperator,
      cantidad: this.formData.Utilizados.cantidad,
      cantidadOperator: this.formData.Utilizados.cantidadOperator,
      fecha: this.formData.Utilizados.fecha ? this.datePipe.transform(this.formData.Utilizados.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.Utilizados.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataUtilizadosService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        // Map through the data to transform fecha_de_alta
        this.data = response.data.map((Utilizados: { fecha_del_saldo: string | number | Date; }) => {
          return {
            ...Utilizados,
            fecha_del_saldo: this.datePipe.transform(Utilizados.fecha_del_saldo, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
        if (this.data.length > 0) {
            this.headerKeys = Object.keys(this.data[0]);
            this.displayedColumns = [...this.headerKeys];
        } else {
            this.headerKeys = [];
            this.displayedColumns = [];
        }

        this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
              this.authService.logout(event);
        }
      }
    });
  }

  fetchDataSalidas() {
    this.trackEvent = 'fetchDataSalidas';
    const searchData = {
      razon_social: this.formData.Salidas.razonSocial,
      rfc: this.formData.Salidas.rfc,
      numero: this.formData.Salidas.numero,
      numeroOperator: this.formData.Salidas.numeroOperator,
      clave: this.formData.Salidas.clave,
      claveOperator: this.formData.Salidas.claveOperator,
      fecha: this.formData.Salidas.fecha ? this.datePipe.transform(this.formData.Salidas.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.Salidas.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataSalidasService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        // Map through the data to transform fecha_de_alta
        this.data = response.data.map((Salidas: { fecha_del_pedimento_pago: string | number | Date; }) => {
          return {
            ...Salidas,
            fecha_del_pedimento_pago: this.datePipe.transform(Salidas.fecha_del_pedimento_pago, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
            if (this.data.length > 0) {
                this.headerKeys = Object.keys(this.data[0]);
                this.displayedColumns = [...this.headerKeys];
            } else {
                this.headerKeys = [];
                this.displayedColumns = [];
            }

            this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
              this.authService.logout(event);
        }
      }
    });
  }

  fetchDataFijo() {
    this.trackEvent = 'fetchDataFijo';
    const searchData = {
      razon_social: this.formData.Fijo.razonSocial,
      rfc: this.formData.Fijo.rfc,
      numero: this.formData.Fijo.numero,
      numeroOperator: this.formData.Fijo.numeroOperator,
      descripcion: this.formData.Fijo.descripcion,
      descripcionOperator: this.formData.Fijo.descripcionOperator,
      clave: this.formData.Fijo.clave,
      claveOperator: this.formData.Fijo.claveOperator,
      fecha: this.formData.Fijo.fecha ? this.datePipe.transform(this.formData.Fijo.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.Fijo.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataFijoService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        // Map through the data to transform fecha_de_alta
        this.data = response.data.map((Fijo: { fecha_del_pedimento_entrada: string | number | Date; }) => {
          return {
            ...Fijo,
            fecha_del_pedimento_entrada: this.datePipe.transform(Fijo.fecha_del_pedimento_entrada, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
            if (this.data.length > 0) {
                this.headerKeys = Object.keys(this.data[0]);
                this.displayedColumns = [...this.headerKeys];
            } else {
                this.headerKeys = [];
                this.displayedColumns = [];
            }

            this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
              this.authService.logout(event);
        }
      }
    });
  }

  fetchDataTempEntrada() {
    this.trackEvent = 'fetchDataTempEntrada';
    const searchData = {
      razon_social: this.formData.TempEntrada.razonSocial,
      rfc: this.formData.TempEntrada.rfc,
      numero: this.formData.TempEntrada.numero,
      numeroOperator: this.formData.TempEntrada.numeroOperator,
      clave: this.formData.TempEntrada.clave,
      claveOperator: this.formData.TempEntrada.claveOperator,
      fecha: this.formData.TempEntrada.fecha ? this.datePipe.transform(this.formData.TempEntrada.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.TempEntrada.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataTempEntradaService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        // Map through the data to transform fecha_de_alta
        this.data = response.data.map((TempEntrada: { fecha_de_pedimento_entrada: string | number | Date; }) => {
          return {
            ...TempEntrada,
            fecha_de_pedimento_entrada: this.datePipe.transform(TempEntrada.fecha_de_pedimento_entrada, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
            if (this.data.length > 0) {
                this.headerKeys = Object.keys(this.data[0]);
                this.displayedColumns = [...this.headerKeys];
            } else {
                this.headerKeys = [];
                this.displayedColumns = [];
            }

            this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
              this.authService.logout(event);
        }
      }
    });
  }

  fetchDataTempSalida() {
    this.trackEvent = 'fetchDataTempSalida';
    const searchData = {
      razon_social: this.formData.TempSalida.razonSocial,
      rfc: this.formData.TempSalida.rfc,
      numero: this.formData.TempSalida.numero,
      numeroOperator: this.formData.TempSalida.numeroOperator,
      clave: this.formData.TempSalida.clave,
      claveOperator: this.formData.TempSalida.claveOperator,
      fecha: this.formData.TempSalida.fecha ? this.datePipe.transform(this.formData.TempSalida.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.TempSalida.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataTempSalidaService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        // Map through the data to transform fecha_de_alta
        this.data = response.data.map((TempSalida: { fecha_pedimento_pago_salida: string | number | Date; }) => {
          return {
            ...TempSalida,
            fecha_pedimento_pago_salida: this.datePipe.transform(TempSalida.fecha_pedimento_pago_salida, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
            if (this.data.length > 0) {
                this.headerKeys = Object.keys(this.data[0]);
                this.displayedColumns = [...this.headerKeys];
            } else {
                this.headerKeys = [];
                this.displayedColumns = [];
            }

            this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
              this.authService.logout(event);
        }
      }
    });
  }

  fetchDataSaldos() {
    this.trackEvent = 'fetchDataSaldos';
    const searchData = {
      razon_social: this.formData.Saldos.razonSocial,
      rfc: this.formData.Saldos.rfc,
      arancelaria: this.formData.Saldos.arancelaria,
      arancelariaOperator: this.formData.Saldos.arancelariaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataSaldosService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);

        // Map through the data to transform fecha_de_alta
        this.data = response.data.map((Saldos: { fecha_vencimiento: string | number | Date; }) => {
          return {
            ...Saldos,
            fecha_vencimiento: this.datePipe.transform(Saldos.fecha_vencimiento, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
        if (this.data.length > 0) {
            this.headerKeys = Object.keys(this.data[0]);
            this.displayedColumns = [...this.headerKeys];
        } else {
            this.headerKeys = [];
            this.displayedColumns = [];
        }

        this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
              this.authService.logout(event);
        }
      }
    });
  }

  fetchDataTempUtilizados() {
    this.trackEvent = 'fetchDataTempUtilizados';
    const searchData = {
      razon_social: this.formData.TempUtilizados.razonSocial,
      rfc: this.formData.TempUtilizados.rfc,
      numero: this.formData.TempUtilizados.numero,
      numeroOperator: this.formData.TempUtilizados.numeroOperator,
      descripcion: this.formData.TempUtilizados.descripcion,
      descripcionOperator: this.formData.TempUtilizados.descripcionOperator,
      unidad: this.formData.TempUtilizados.unidad,
      unidadOperator: this.formData.TempUtilizados.unidadOperator,
      fecha: this.formData.TempUtilizados.fecha ? this.datePipe.transform(this.formData.TempUtilizados.fecha, 'yyyy-MM-dd') : '',
      fechaOperator: this.formData.TempUtilizados.fechaOperator,
      start: (this.currentPage - 1) * this.pageSize,
      length: this.pageSize
    };

    this.generalService.fetchDataTempUtilizadosService(searchData).subscribe({
      next: (response) => {
        //console.log('API Response:', response);
        
        this.data = response.data.map((TempUtilizados: { del: string | number | Date; fecha_fin: string | number | Date; fecha_inicio: string | number | Date }) => {
          return {
            ...TempUtilizados,
            del: this.datePipe.transform(TempUtilizados.del, 'yyyy-MM-dd'),
            fecha_fin: this.datePipe.transform(TempUtilizados.fecha_fin, 'yyyy-MM-dd'),
            fecha_inicio: this.datePipe.transform(TempUtilizados.fecha_inicio, 'yyyy-MM-dd')
          };
        });

        this.totalRecords = response.recordsTotal;
        this.filteredRecords = response.recordsFiltered;

        this.totalPages = Math.ceil(this.filteredRecords / this.pageSize);
            if (this.data.length > 0) {
                this.headerKeys = Object.keys(this.data[0]);
                this.displayedColumns = [...this.headerKeys];
            } else {
                this.headerKeys = [];
                this.displayedColumns = [];
            }

            this.tableView = true;
      },
      error: (error) => {
        this.data = [];
        this.headerKeys = [];
        this.displayedColumns = [];
        this.tableView = true;
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.totalPages = 1; // Reset totalPages on error
        console.error('Error fetching data:', error);
        if (error.status === 401) {
          const event = "session"
              this.authService.logout(event);
        }
      }
    });
  }

  changePage(page: number) {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    if(this.trackEvent == 'fetchDataMateriales'){
      this.fetchDataMateriales();
    }else if(this.trackEvent == 'fetchDataProductos'){
      this.fetchDataProductos();
    }else if(this.trackEvent == 'fetchDataEntradas'){
      this.fetchDataEntradas();
    }else if(this.trackEvent == 'fetchDataUtilizados'){
      this.fetchDataUtilizados();
    }else if(this.trackEvent == 'fetchDataSalidas'){
      this.fetchDataSalidas();
    }else if(this.trackEvent == 'fetchDataFijo'){
      this.fetchDataFijo();
    }else if(this.trackEvent == 'fetchDataTempEntrada'){
      this.fetchDataTempEntrada();
    }else if(this.trackEvent == 'fetchDataTempSalida'){
      this.fetchDataTempSalida();
    }else if(this.trackEvent == 'fetchDataSaldos'){
      this.fetchDataSaldos();
    }else if(this.trackEvent == 'fetchDataTempUtilizados'){
      this.fetchDataTempUtilizados();
    }else{
      console.log("Please select the search first")
    }
  }

  sortData(column: string) {
    this.sortDirection = this.sortColumn === column ? (this.sortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
    this.sortColumn = column;

    this.data.sort((a, b) => {
      if (a[column] < b[column]) return this.sortDirection === 'asc' ? -1 : 1;
      if (a[column] > b[column]) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  capitalizeHeader(key: string): string {
    return key.replace(/_/g, ' ').toUpperCase();
  }
  

  maxDate: string = this.calculateMaxDate();

  calculateMaxDate(): string {
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() - 6);
    currentDate.setMonth(currentDate.getMonth() - 6);
    return currentDate.toISOString().split('T')[0];
  }
}
